import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Mail, MapPin } from 'lucide-react';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const navItems = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About Us' },
    { path: '/services', label: 'Services' },
    { path: '/gallery', label: 'Gallery' },
    { path: '/contact', label: 'Contact' },
  ];

  return (
    <>
      {/* Top Bar */}
      <div className="top-bar">
        <div className="container">
          <div className="top-bar-content">
            <div className="contact-info">
              <div className="contact-item">
                <Phone size={16} />
                <span>+91 8829988116</span>
              </div>
              <div className="contact-item">
                <Mail size={16} />
                <span>shyamhealthcares@gmail.com</span>
              </div>
              <div className="contact-item">
                <MapPin size={16} />
                <span>Jaipur, India</span>
              </div>
            </div>
            <div className="emergency-contact">
              <span>P.Lt 2, Triveni Nagar ll, Niwaru Rd, Jhotwara</span>
            </div>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
        <div className="container">
          <div className="header-content">
            {/* Logo */}
            <Link to="/" className="logo" onClick={closeMenu}>
              <img 
                src="/images/logo.png" 
                alt="Shyam Healthcares" 
                className="logo-image"
                width="150"
                height="50"
                loading="eager"
              />
            </Link>

            {/* Desktop Navigation */}
            <nav className="desktop-nav">
              <ul>
                {navItems.map((item) => (
                  <li key={item.path}>
                    <Link
                      to={item.path}
                      className={location.pathname === item.path ? 'active' : ''}
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>

            {/* CTA Button */}
            <div className="header-cta">
              <button 
                className="btn btn-primary"
                onClick={() => window.location.href = 'tel:+918829988116'}
              >
                Book Now
              </button>
            </div>

            {/* Mobile Menu Button */}
            <button
              className="mobile-menu-btn"
              onClick={toggleMenu}
              aria-label="Toggle menu"
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        <nav className={`mobile-nav ${isMenuOpen ? 'open' : ''}`}>
          <ul>
            {navItems.map((item) => (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className={location.pathname === item.path ? 'active' : ''}
                  onClick={closeMenu}
                >
                  {item.label}
                </Link>
              </li>
            ))}
            
            {/* Contact Information in Mobile Menu */}
            <li className="mobile-contact-section">
              <div className="mobile-contact-title">Contact Info</div>
              <div className="mobile-contact-item">
                <Phone size={16} />
                <a href="tel:+918829988116">+91 8829988116</a>
              </div>
              <div className="mobile-contact-item">
                <Mail size={16} />
                <a href="mailto:shyamhealthcares@gmail.com">shyamhealthcares@gmail.com</a>
              </div>
              <div className="mobile-contact-item">
                <MapPin size={16} />
                <span>P.Lt 2, Triveni Nagar ll, Niwaru Rd, Jhotwara, Jaipur, India</span>
              </div>
            </li>
          </ul>
        </nav>
      </header>
    </>
  );
};

export default Header;
